import type { ReactNode } from "react";
import { SiteHeader } from "@/components/site-header";
import { SiteFooter } from "@/components/site-footer";
import type { Locale, SectionKey } from "@/lib/i18n";
import { buildBreadcrumbJsonLd } from "@/lib/structured-data";

export function SiteShell({
  locale,
  breadcrumbSection,
  children,
}: {
  locale: Locale;
  /** İç sayfada BreadcrumbList JSON-LD (Ana sayfa → bölüm). */
  breadcrumbSection?: SectionKey;
  children: ReactNode;
}) {
  const breadcrumbLd = breadcrumbSection
    ? buildBreadcrumbJsonLd(locale, breadcrumbSection)
    : null;

  return (
    <div className="flex min-h-full flex-1 flex-col bg-background text-foreground">
      {breadcrumbLd ? (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbLd) }}
        />
      ) : null}
      <SiteHeader locale={locale} />
      <main className="flex flex-1 flex-col">{children}</main>
      <SiteFooter locale={locale} />
    </div>
  );
}
